<h2 #dialogDrag="cdkDrag" mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle (cdkDragEnded)="rememberPosition()" style="color: white">
    <span style="width: 100%; display: inline-flex; justify-content: space-between; align-items: center">
        <span>
            {{ heading }}
        </span>
        <div style="display: flex; align-items: center">
            <tt-overflow-menu class="tt-state-dialog__overflow-menu">
                <tt-overflow-menu-item ttIcon="fal fa-undo" ttText="state_modal_reset_size" (ttClick)="resetSize()"></tt-overflow-menu-item>
                <tt-overflow-menu-item ttIcon="fal fa-play-circle" ttText="navbar_video_help" (ttClick)="navbar.openVideoTutorialsDialog('webpage_name', data.state)"></tt-overflow-menu-item>
                <tt-overflow-menu-item ttIcon="fal fa-question-circle" ttText="navbar_helpdoc" (ttClick)="navbar.openHelpDocDialog(data.state)"></tt-overflow-menu-item>
            </tt-overflow-menu>
            <button style="background: transparent; border: none; margin: none; outline: none; padding: none; color: white" (click)="dialogRef.close()"><span class="far fa-times"></span></button>
        </div>
    </span>
</h2>

<mat-dialog-content class="tt-state-dialog__content">
    <ng-container *ngComponentOutlet="component; injector: injector"></ng-container>
</mat-dialog-content>

<button class="tt-state-dialog__resize-handle" type="button" aria-label="Resize modal" title="Resize modal" (pointerdown)="startResize($event)" (keydown)="resizeWithKeyboard($event)"></button>
